// @generated by protoc-gen-connect-es v1.1.2 with parameter "target=ts"
// @generated from file swell/v3/staker.proto (package swell.v3, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { StakesRequest, StakesResponse } from "./staker_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service swell.v3.StakerService
 */
export const StakerService = {
  typeName: "swell.v3.StakerService",
  methods: {
    /**
     * @generated from rpc swell.v3.StakerService.Stakes
     */
    stakes: {
      name: "Stakes",
      I: StakesRequest,
      O: StakesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

